import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createCustomer } from "../../../helpers/urlConfig/apiFunctions";
import {
  errorToastify,
  successToastify,
} from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";

function CustomerCreate({
  customer_modal_list,
  set_customer_modal_list,
  customer_tog_list,
  fetchData,
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      // Replace with your API endpoint
      data.created_by = getSessionData("user_id");
      const response = await createCustomer(data);

      if (response.statusCode === 200) {
        successToastify("Customer created successfully");
        fetchData();
        set_customer_modal_list(false);
        reset();
      }

      if (response.statusCode === 400) {
        if (response.data.errno === 1062) {
          errorToastify("Customer already exists");
        }
      }

      console.error("error create customer", response);
    } catch (error) {
      // Handle error
      console.error("Error adding product:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal
        isOpen={customer_modal_list}
        toggle={() => {
          customer_tog_list();
        }}
        centered
      >
        <ModalHeader
          className="bg-light p-3"
          toggle={() => {
            customer_tog_list();
          }}
        >
          {" "}
          Add Customer{" "}
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="mb-3" id="modal-id" style={{ display: "none" }}>
              <label htmlFor="id-field" className="form-label">
                ID
              </label>
              <input
                type="text"
                id="id-field"
                className="form-control"
                placeholder="ID"
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="customername-field" className="form-label">
                Customer Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="customername-field"
                className="form-control"
                placeholder="Enter Name"
                {...register("customer_name", {
                  required: "Customer Name is required",
                })}
              />
              {errors.customer_name && (
                <div className="invalid-feedback">
                  {errors.customer_name.message}
                </div>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="phone-field" className="form-label">
                Mobile Number
              </label>
              <input
                type="text"
                id="phone-field"
                className="form-control"
                placeholder="Enter Phone no."
                {...register("phone_number")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="date-field" className="form-label">
                Address
              </label>
              <textarea
                type="text"
                id="phone-field"
                className="form-control"
                placeholder="Enter Address."
                {...register("address")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                Place <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter Place"
                {...register("place", {
                  required: "Place is required",
                })}
              />
              {errors.place && (
                <div className="invalid-feedback">{errors.place.message}</div>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                GST Details
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter GST Details"
                {...register("gst_details")}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email-field" className="form-label">
                Pan Card Details
              </label>
              <input
                type="text"
                id="email-field"
                className="form-control"
                placeholder="Enter Pan Card Details"
                {...register("pan_details")}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => set_customer_modal_list(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success" id="add-btn">
                Add Customer
              </button>
              {/* <button type="button" className="btn btn-success" id="edit-btn">Update</button> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default CustomerCreate;
